import "./style.css";
const FontSetting = () => {
  return null;
};

export default FontSetting;
